import type { GameModePreference } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { GAME_MODE_PREFERENCE_MAP } from '@/features/profile/utils/gameModePreference';
import { Badge } from '@/shared/components/ui/badge';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibeQueueStylePreferenceProps extends HTMLAttributes<HTMLDivElement> {
  gameModePreference?: GameModePreference;
}

export const ProfileDetailsVibeQueueStylePreference = memo(
  function ProfileDetailsVibeQueueStylePreference({
    gameModePreference,
    ...props
  }: ProfileDetailsVibeQueueStylePreferenceProps) {
    if (!gameModePreference) return null;

    const option = GAME_MODE_PREFERENCE_MAP.get(gameModePreference);
    if (!option) return null;

    return (
      <Card variant="data" {...props}>
        <p className="text-sm leading-5 font-bold">Queue style preference</p>
        <Badge variant="display">
          {option.icon} {option.label}
        </Badge>
      </Card>
    );
  },
);
